import React, { useState } from 'react'
import styles from './app.module.css'
import Navbar from '../../Navbar/Navbar.js'
import EmployeeReuqest from './EmployeeReuqest.jsx'
import VendorEmployeeRequest from './VendorEmployeeRequest.jsx'
 

export default function UserRequestComponent() {
  const [activeTab, setActiveTab] = useState("employee")

  const handleTabClick = (tab) => {
    setActiveTab(tab)
  }

  return (
    <div className={styles.container}>
      <Navbar />
      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.tabs}>
            <button
              className={`${styles.tabButton} ${activeTab === "employee" ? styles.activeTab : ''}`}
              onClick={() => handleTabClick("employee")}
            >
              Employee
            </button>
            <button
              className={`${styles.tabButton} ${activeTab === "client" ? styles.activeTab : ''}`}
              onClick={() => handleTabClick("client")}
            >
              Client
            </button>
          </div>
       
          <div className={styles.tabContent}>
            {activeTab === "employee" && (
            //   <div>
            //     <h2 className={styles.contentTitle}>Employee Content</h2>
            //     <p>This is where the employee-specific content would go.</p>
            //   </div>
            <EmployeeReuqest />
            )}
            {activeTab === "client" && (

                <VendorEmployeeRequest />
            //   <div>
            //     <h2 className={styles.contentTitle}>Client Content</h2>
            //     <p>This is where the client-specific content would go.</p>
            //   </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}